<template>
  <div class="v-subscribe-form">
    <div class="form__heading">
      <h2 class="form__title">{{ businessTitle }}</h2>
    </div>
    <div class="form__block">
      <ul v-if="website == 'athome'" class="form__list">
        <li class="form__item">
          <v-radios-public
            name="business_registration"
            :options="businessRadioOptions"
            :value="business_form_state"
            :label="businessLabel"
            @input="triggerBusinessForm"
            v-validate="`required|make_choice`"
          ></v-radios-public>
        </li>
      </ul>
    </div>
    <div id="business-form" v-if="business_form_state === '1'">
      <input
        type="hidden"
        name="business_registration"
        value="1"
        v-if="website == 'staffhousing'"
      />
      <ul class="form__list">
        <li class="form__item">
          <v-textfield-public
            :label="companyName"
            :name="companyNameInput"
            v-validate="`required`"
          ></v-textfield-public>
        </li>
        <template v-if="website == 'staffhousing'">
          <li class="form__item">
            <v-textfield-public
              :label="
                (locales &&
                  locales.subscriptions &&
                  locales.subscriptions.contact_person + ' ') +
                subscriptionsFirstName
              "
              :name="subscriptionsFirstNameInput"
              v-validate="`alpha_spaces_dash`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="
                (locales &&
                  locales.subscriptions &&
                  locales.subscriptions.contact_person + ' ') +
                subscriptionsMiddleName
              "
              :name="subscriptionsMiddleNameInput"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="
                (locales &&
                  locales.subscriptions &&
                  locales.subscriptions.contact_person + ' ') +
                subscriptionsLastName
              "
              :name="subscriptionsLastNameInput"
              v-validate="`alpha_spaces_dash`"
            ></v-textfield-public>
          </li>
        </template>
        <li class="form__item" v-else>
          <v-textfield-public
            :label="companyLegalForm"
            :name="companyLegalFormInput"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            v-if="website == 'staffhousing'"
            :label="companyChamberOfCommerceNumber"
            :name="companyChamberOfCommerceNumberInput"
            v-validate="`alpha_num_spaces`"
          ></v-textfield-public>
          <v-textfield-public
            v-else
            :label="companyChamberOfCommerceNumber"
            :name="companyChamberOfCommerceNumberInput"
            v-validate="`alpha_num_spaces`"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            v-if="website == 'staffhousing'"
            :label="companyVatNumber"
            :name="companyVatNumberInput"
            v-validate="`alpha_num_spaces`"
          ></v-textfield-public>
          <v-textfield-public
            v-else
            :label="companyVatNumber"
            :name="companyVatNumberInput"
            v-validate="`alpha_num_spaces`"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyPhoneNumber + ' (*)'"
            v-if="website == 'staffhousing'"
            :name="companyPhoneNumberInput"
            v-validate="`required|phone_number`"
          ></v-textfield-public>
          <v-textfield-public
            :label="companyPhoneNumber"
            v-else
            :name="companyPhoneNumberInput"
          ></v-textfield-public>
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyEmail + ' (*)'"
            v-if="website == 'staffhousing'"
            :name="companyEmailInput"
            v-validate="`required|email`"
            @blur="checkMail"
          ></v-textfield-public>
          <v-textfield-public
            :label="companyEmail"
            v-else
            :name="companyEmailInput"
          ></v-textfield-public>
        </li>
        <li class="form__item" v-if="is_user_already_exists==1">
          <label class="form__label"></label>
          <b style="color: red;">{{isUserAlreadyExists}}</b>
          <input type="hidden" name="user_already_exists" v-validate="`required`">
        </li>
        <li class="form__item" v-if="is_user_already_exists==2">
          <label class="form__label"></label>
          <b style="color: red;">{{isUserBanned}}</b>
          <input type="hidden" name="user_already_exists" v-validate="`required`">
        </li>
        <li class="form__item">
          <v-textfield-public
            :label="companyInvoiceEmail"
            :name="companyInvoiceEmailInput"
          ></v-textfield-public>
        </li>
      </ul>
    </div>
    <div id="personal-form" v-if="business_form_state === '0'">
      <div class="form__heading">
        <h2 class="form__title">{{ subscriptionsFamilyType }}</h2>
      </div>
      <ul class="form__list">
        <li class="form__item">
          <v-radios-public
            :label="subscriptionsIAm"
            :name="subscriptionsFamilyTypeInput"
            :options="subscriptionsFamilyTypeOptions"
            @input="triggerFamilyType"
            v-validate="`required|make_choice`"
          ></v-radios-public>
        </li>
        <li v-if="family_type_state == 'several_friends'" class="form__item">
          <v-textfield-public
            :label="subscriptionNumberOfAdults"
            name="number_of_adults"
            v-model.number="number_of_adults_value"
            v-validate="`required|numeric|min_value:0|max_value:5`"
          ></v-textfield-public>
        </li>
      </ul>
      <div class="form__heading">
        <h2 class="form__title">{{ subscriptionsIncome }}</h2>
      </div>
      <ul class="form__list">
        <li class="form__item">
          <v-checkboxes-public
            :label="subscriptionsIAm"
            :name="subscriptionsTypeOfIncomeInput"
            :options="subscriptionsTypeOfIncomeOptions"
            @input="triggerIncomeAdditionalForms"
            v-validate="`required|make_choice`"
          ></v-checkboxes-public>
        </li>
        <!-- working or business -->
        <template v-if="income_form_work_business">
          <li class="form__item" v-if="income_form_work">
            <v-radios-public
              :label="usersContractType"
              :name="usersContractTypeInput"
              :options="usersContractTypeOptions"
              @input="triggerContractDuration"
              v-validate="`required|make_choice`"
            ></v-radios-public>
          </li>
          <template v-if="showDuration && income_form_work">
            <li class="form__item">
              <v-textfield-public
                :label="usersContractDuration"
                :name="usersContractDurationInput"
                v-validate="`required|numeric`"
              ></v-textfield-public>
            </li>
            <li class="form__item">
              <v-datepicker-public
                :label="usersContractEndDate"
                :name="usersContractEndDateInput"
                v-validate="`required`"
              ></v-datepicker-public>
            </li>
          </template>
          <li class="form__item">
            <v-textfield-public
              :label="usersOccupation"
              :name="usersOccupationInput"
              v-validate="`required`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="usersMonthlyIncome"
              :name="usersMonthlyIncomeInput"
              v-validate="`required|numeric`"
            ></v-textfield-public>
            <div class="form__bottom-row">{{ usersMonthlyIncomeNote }}</div>
          </li>

          <li class="form__item">
            <v-radios-public
              :label="usersDoYouHaveGuarantorGeneral"
              :name="usersDoYouHaveGuarantorInput"
              :options="usersDoYouHaveGuarantorOptions"
              @input="triggerGuarantorForm"
              v-validate="`make_choice`"
            ></v-radios-public>
          </li>
          <li v-if="guarantor_form_state == 1" class="form__item">
            <v-textfield-public
              :label="usersGuarantorIncome"
              :name="usersGuarantorIncomeInput"
              v-validate="`numeric`"
            ></v-textfield-public>
          </li>
        </template>
        <!-- studying -->
        <template v-if="income_form_studying">
          <template v-if="!income_form_work_business">
            <li class="form__item">
              <v-radios-public
                :label="usersDoYouHaveGuarantor"
                :name="usersDoYouHaveGuarantorInput"
                :options="usersDoYouHaveGuarantorOptions"
                @input="triggerGuarantorForm"
                v-validate="`required|make_choice`"
              ></v-radios-public>
            </li>
            <li
              v-if="guarantor_form_state == 0 || guarantor_form_state == 2"
              class="form__item"
            >
              <v-radios-public
                :label="usersDoYouHaveOtherGuaranteeOptions"
                :name="usersDoYouHaveOtherGuaranteeOptionsInput"
                v-model="users_do_you_have_other_guarantee_options_value"
                :options="usersDoYouHaveOtherGuaranteeOptionsOptions"
                v-validate="`required|make_choice`"
              ></v-radios-public>
            </li>
            <li
              v-if="
                users_do_you_have_other_guarantee_options_value == 0 &&
                (guarantor_form_state == 0 || guarantor_form_state == 2)
              "
              class="form__item"
            >
              <div class="form__field-box">
                <strong style="color: red">{{ declineFormMessage }}</strong>
              </div>
              <input
                type="hidden"
                name="cant_rent_a_house"
                v-validate="`required`"
              />
            </li>
            <li v-if="guarantor_form_state == 1" class="form__item">
              <v-textfield-public
                :label="usersGuarantorIncome"
                :name="usersGuarantorIncomeInput"
                v-validate="`required|numeric`"
              ></v-textfield-public>
            </li>
          </template>
          <li class="form__item">
            <v-textfield-public
              :label="usersStudy"
              :name="usersStudyInput"
              v-validate="`required`"
            ></v-textfield-public>
          </li>
        </template>
        <li v-if="income_form_any" class="form__item form__item--align-start">
          <label class="form__label">{{ usersExtraInformationIncome }}</label>
          <textarea
            class="form__textarea"
            :name="usersExtraInformationIncomeInput"
            >{{ usersIncomeNote }}</textarea
          >
        </li>
      </ul>
    </div>
    <div class="form__heading" v-if="website != 'staffhousing'">
      <h2 class="form__title">{{ usersLandlordDetails }}</h2>
    </div>
    <ul class="form__list" v-if="website != 'staffhousing'">
      <li class="form__item">
        <v-radios-public
          :label="usersLandlordLabel"
          :name="usersLandlordRadio"
          :options="usersLandlordOptions"
          @input="triggerLandlordType"
        ></v-radios-public>
      </li>
      <li v-if="landlord_type_state == 'renting_property'" class="form__item">
        <ul class="form__list">
          <li class="form__item">
            <v-textfield-public
              :label="usersLandlordName"
              name="person[0][landlord_name]"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="usersLandlordEmail"
              name="person[0][landlord_email]"
              v-validate="`email`"
            ></v-textfield-public>
          </li>
          <li class="form__item">
            <v-textfield-public
              :label="usersLandlordPhone"
              name="person[0][landlord_phone_number]"
              v-validate="`phone_number`"
            ></v-textfield-public>
          </li>
        </ul>
      </li>
    </ul>

    <div class="form__heading" v-if="website != 'staffhousing'">
      <h2 class="form__title">{{ subscriptionsYourDetails }}</h2>
    </div>
    <ul class="form__list" v-if="website != 'staffhousing'">
      <li class="form__item form__item--no-label">
        <v-radios-public
          :validation-label="(locales && locales.users && locales.users.title)+` (*)`"
          :name="subscriptionsSexInput"
          :options="subscriptionsSexOptions"
          v-validate="`required|make_choice`"
        ></v-radios-public>
      </li>
      <li class="form__item">
        <v-radios-public
          :label="locales && locales.users && locales.users.language"
          :value="defaultLanguage"
          name="person[0][language]"
          show-zero-option="0"
          :options="languages"
          v-validate="`required`"
        ></v-radios-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsFirstName"
          :name="subscriptionsFirstNameInput"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsMiddleName"
          :name="subscriptionsMiddleNameInput"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsLastName"
          :name="subscriptionsLastNameInput"
          v-validate="`required|alpha_spaces_dash`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="subscriptionsPostCode"
          :label="locales && locales.users && locales.users.post_code"
          @blur="checkPcHn($event)"
          ref="person_postcode_0"
          class="js-postcode"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="subscriptionsHouseNumber"
          :label="locales && locales.users && locales.users.house_number"
          class="js-house-number"
          ref="person_housenumber_0"
          @blur="checkPostcodeAddress($event)"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :name="subscriptionsStreet"
          ref="person_street_0"
          :label="locales && locales.users && locales.users.street"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :is-update-model="true"
          ref="person_city_0"
          :name="subscriptionsCity"
          :label="locales && locales.users && locales.users.city"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="website == 'athome'">
        <v-datepicker-public
          :label="subscriptionsDateOfBirth"
          :name="subscriptionsDateOfBirthInput"
          v-validate="`required`"
        ></v-datepicker-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          type="tel"
          :label="subscriptionsPhoneNumber"
          :name="subscriptionsPhoneNumberInput"
          class="js-unique-phone"
          @blur="checkPhone"
          v-validate="`required|tel`"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="!!is_phone_number_unique">
        <label class="form__label"></label>
        <b style="color: red">{{ phoneNumberAlreadyExists }}</b>
        <input
          type="hidden"
          name="phone_number_unique"
          v-validate="`required`"
        />
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsEmail"
          :name="subscriptionsEmailInput"
          type="email"
          class="js-unique-mail"
          :is-prefill-disabled="true"
          @blur="checkMail"
          v-validate="`required|email`"
        ></v-textfield-public>
      </li>
      <li class="form__item" v-if="is_user_already_exists == 1">
        <label class="form__label"></label>
        <b style="color: red">{{ isUserAlreadyExists }}</b>
        <input
          type="hidden"
          name="user_already_exists"
          v-validate="`required`"
        />
      </li>
      <li class="form__item" v-else-if="is_user_already_exists == 2">
        <label class="form__label"></label>
        <b style="color: red">{{ isUserBanned }}</b>
        <input
          type="hidden"
          name="user_already_exists"
          v-validate="`required`"
        />
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsPassword"
          :name="subscriptionsPasswordInput"
          type="password"
          :is-prefill-disabled="true"
          ref="password0"
          v-validate="`required`"
        ></v-textfield-public>
      </li>
      <li class="form__item">
        <v-textfield-public
          :label="subscriptionsPasswordRepeat"
          :name="subscriptionsPasswordRepeatInput"
          type="password"
          :is-prefill-disabled="true"
          v-validate="`required|confirmed:password0`"
        ></v-textfield-public>
      </li>
    </ul>
    <div
      v-if="number_of_adults_value > 1"
      v-for="adult in number_of_adults_value_computed - 1"
      :key="adult"
    >
      <v-subscribe-inner-form
        :i="adult"
        :partner="partner"
        :family-type-state="family_type_state"
        :subscriptions="innerFormSubscriptions"
        :users-title-options="innerFormUsersTitleOptions"
        :users-first-name="subscriptionsFirstName"
        :users-middle-name="subscriptionsMiddleName"
        :users-last-name="subscriptionsLastName"
        :users-date-of-birth="subscriptionsDateOfBirth"
        :users-phone-number="subscriptionsPhoneNumber"
        :users-email="subscriptionsEmail"
        :users-i-am="subscriptionsIAm"
        :users-type-of-income-options="subscriptionsTypeOfIncomeOptions"
        :users-occupation="usersOccupation"
        :users-contract-type="usersContractType"
        :users-contract-type-options="usersContractTypeOptions"
        :users-contract-type-attributes="usersContractTypeAttributes"
        :users-contract-duration="usersContractDuration"
        :users-contract-end-date="usersContractEndDate"
        :users-monthly-income="usersMonthlyIncome"
        :users-monthly-income-note="usersMonthlyIncomeNote"
        :users-do-you-have-guarantor="usersDoYouHaveGuarantor"
        :users-do-you-have-guarantor-options="usersDoYouHaveGuarantorOptions"
        :users-guarantor-income="usersGuarantorIncome"
        :users-study="usersStudy"
        :users-extra-information-income="usersExtraInformationIncome"
        :users-type-of-income-slugs="subscriptionsTypeOfIncomeSlugs"
        :income-form-all-states="incomeFormAllStates"
        :income-title="subscriptionsIncome"
        :income-is-user-already-exists="isUserAlreadyExists"
        :income-is-user-banned="isUserBanned"
        :income-phone-number-already-exists="phoneNumberAlreadyExists"
        :users-landlord-options="usersLandlordOptions"
        :languages="languages"
        :default-language="defaultLanguage"
      ></v-subscribe-inner-form>
    </div>
    <v-search-profile-form
      :website="website"
      :search-profile-title="searchProfileTitle"
      :sp-city-title="spCityTitle"
      :sp-district-title="spDistrictTitle"
      :sp-distance-title="spDistanceTitle"
      :sp-distance-options="spDistanceOptions"
      :sp-distance-value="spDistanceValue"
      :sp-rental-price-from-title="spRentalPriceFromTitle"
      :sp-rental-price-from-options="spRentalPriceFromOptions"
      :sp-rental-price-from-value="spRentalPriceFromValue"
      :sp-rental-price-to-title="spRentalPriceToTitle"
      :sp-rental-price-to-options="spRentalPriceToOptions"
      :sp-rental-price-to-value="spRentalPriceToValue"
      :sp-bedrooms-title="spBedroomsTitle"
      :sp-bedrooms-options="spBedroomsOptions"
      :sp-bedrooms-value="spBedroomsValue"
      :sp-surface-title="spSurfaceTitle"
      :sp-surface-options="spSurfaceOptions"
      :sp-surface-value="spSurfaceValue"
      :sp-property-type-title="spPropertyTypeTitle"
      :sp-property-type-options="spPropertyTypeOptions"
      :sp-property-type-value="spPropertyTypeValue"
      :sp-interior-title="spInteriorTitle"
      :sp-interior-options="spInteriorOptions"
      :sp-interior-value="spInteriorValue"
      :sp-suitable-for-sharing-title="spSuitableForSharingTitle"
      :sp-suitable-for-sharing-options="spSuitableForSharingOptions"
      :sp-suitable-for-sharing-value="spSuitableForSharingValue"
      :sp-parking-space-title="spParkingSpaceTitle"
      :sp-parking-space-options="spParkingSpaceOptions"
      :sp-parking-space-value="spParkingSpaceValue"
      :sp-rent-period-title="spRentPeriodTitle"
      :sp-rent-period-options="spRentPeriodOptions"
      :sp-rent-period-value="spRentPeriodValue"
      :sp-start-date-rent-title="spStartDateRentTitle"
      :sp-start-date-rent-value="spStartDateRentValue"
      :sp-extra-information-title="spExtraInformationTitle"
      :sp-no-preference="spNoPreference"
      :sp-add="spAdd"
      :sp-reduce="spReduce"
      :sp-rental-text-title="spRentalTextTitle"
      :sp-week-price-title="spWeekPriceTitle"
      :sp-number-of-men-title="spNumberOfMenTitle"
      :sp-number-of-women-title="spNumberOfWomenTitle"
      :sp-min-number-of-bedrooms-title="spMinNumberOfBedroomsTitle"
      :sp-parking-places-title="spParkingPlacesTitle"
      :sp-parking-places-options="spParkingPlacesOptions"
    ></v-search-profile-form>
    <ul class="form__list">
      <li class="form__item" v-if="website != 'staffhousing'">
        <v-checkboxes-public
          :label-html="subscribeToNewsletter"
          class="form__radio"
          :options="{ '1': '' }"
          name
          v-validate="`required`"
        ></v-checkboxes-public>
      </li>
      <template v-if="website != 'staffhousing'">
        <li class="form__item">
          {{ requestSrcInfo }}
        </li>
        <li class="form__item form__item--center form__item--request-src">
          <v-checkboxes-public
            :label-html="requestSrc"
            class="form__radio"
            :options="{ '1': '' }"
            disabled="disabled"
            name="request_src"
            id="requestSrcCheckbox"
          ></v-checkboxes-public>
          <i class="func-request-src-item form-checkbox-info"
            >({{ checkBoxInfo }})</i
          >
        </li>
      </template>
      <li class="form__item">
        <button
          id="submitFormBtn"
          class="form__button"
          type="submit"
          @click.prevent="submitForm"
        >
          {{ commonSend }}
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
import VTextfieldPublic from "./VTextfieldPublic";
import VDatepickerPublic from "./VDatepickerPublic.vue";
import sweetalert from "sweetalert";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    VTextfieldPublic,
    VDatepickerPublic,
  },
  data() {
    return {
      income_form_any: false,
      income_form_studying: false,
      income_form_work_business: false,
      income_form_work: false,
      income_form_all_states: this.incomeFormAllStates,
      income_form_state: this.incomeFormState,
      number_of_adults_form_state: this.numberOfAdultsFormState,
      guarantor_form_state: this.guarantorFormState,
      landlord_type_state: this.landlordTypeState,
      company_legal_form_value: this.companyLegalFormValue,
      number_of_adults_value: this.subscriptionNumberOfAdultsValue,
      users_do_you_have_other_guarantee_options_value: -1,
      family_type_state: null,
      is_user_already_exists: 0,
      is_phone_number_unique: 0,
      business_state_true: "1",
      business_state_false: "0",
      business_state: "",
      isSubmitInProgress: false,
      showDuration: false,
    };
  },
  computed: {
    ...mapGetters(["locales"]),
    number_of_adults_value_computed: function () {
      if (this.number_of_adults_value >= 1) {
        return this.number_of_adults_value;
      } else {
        return 1;
      }
    },
    website: function () {
      if (this.websiteId != 2) {
        return "athome";
      } else {
        return "staffhousing";
      }
    },
    business_form_state: {
      get: function () {
        if (this.business_state != "") {
          return this.business_state;
        } else {
          if (this.websiteId != 2) {
            return this.business_state_false;
          } else {
            return this.business_state_true;
          }
        }
      },
      set: function (newValue) {
        if (newValue) {
          this.business_state = newValue;
        }
      },
    },
  },
  props: {
    partner: {
      default: "",
      type: String,
    },
    businessTitle: {
      default: "",
      type: String,
    },
    businessLabel: {
      default: "",
      type: String,
    },
    businessRadioOptions: {
      default: () => {},
      type: Object,
    },
    incomeFormAllStates: {
      default: () => [],
      type: Array,
    },
    incomeFormState: {
      default: () => [],
      type: Array,
    },
    guarantorFormState: {
      default: "-1",
      type: String,
    },
    landlordTypeState: {
      default: "-1",
      type: String,
    },
    numberOfAdultsFormState: {
      default: "",
      type: String,
    },
    companyName: {
      default: "",
      type: String,
    },
    companyNameInput: {
      default: "",
      type: String,
    },
    companyLegalForm: {
      default: "",
      type: String,
    },
    companyLegalFormInput: {
      default: "",
      type: String,
    },
    companyLegalFormValue: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumber: {
      default: "",
      type: String,
    },
    companyChamberOfCommerceNumberInput: {
      default: "",
      type: String,
    },
    companyVatNumber: {
      default: "",
      type: String,
    },
    companyVatNumberInput: {
      default: "",
      type: String,
    },
    companyPhoneNumber: {
      default: "",
      type: String,
    },
    companyPhoneNumberInput: {
      default: "",
      type: String,
    },
    companyEmail: {
      default: "",
      type: String,
    },
    companyEmailInput: {
      default: "",
      type: String,
    },
    companyInvoiceEmail: {
      default: "",
      type: String,
    },
    companyInvoiceEmailInput: {
      default: "",
      type: String,
    },
    subscriptionsFamilyType: {
      default: "",
      type: String,
    },
    subscriptionsFamilyTypeInput: {
      default: "",
      type: String,
    },
    subscriptionsFamilyTypeOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsFamilyTypeSlugs: {
      default: () => {},
      type: Object,
    },
    subscriptionsIncome: {
      default: "",
      type: String,
    },
    subscriptionsIAm: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomeInput: {
      default: "",
      type: String,
    },
    subscriptionsTypeOfIncomeOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsTypeOfIncomeSlugs: {
      default: () => {},
      type: Object,
    },
    usersContractType: {
      default: "",
      type: String,
    },
    usersContractTypeInput: {
      default: "",
      type: String,
    },
    usersContractTypeOptions: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractTypeAttributes: {
      default: () => {},
      type: [Object, Array],
    },
    usersContractDuration: {
      default: "",
      type: String,
    },
    usersContractDurationInput: {
      default: "",
      type: String,
    },
    usersContractEndDate: {
      default: "",
      type: String,
    },
    usersContractEndDateInput: {
      default: "",
      type: String,
    },
    usersOccupation: {
      default: "",
      type: String,
    },
    usersOccupationInput: {
      default: "",
      type: String,
    },
    usersMonthlyIncome: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeInput: {
      default: "",
      type: String,
    },
    usersMonthlyIncomeNote: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantor: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorGeneral: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorInput: {
      default: "",
      type: String,
    },
    usersDoYouHaveGuarantorOptions: {
      default: () => {},
      type: Object,
    },
    usersDoYouHaveOtherGuaranteeOptions: {
      default: "",
      type: String,
    },
    usersDoYouHaveOtherGuaranteeOptionsInput: {
      default: "",
      type: String,
    },
    usersDoYouHaveOtherGuaranteeOptionsOptions: {
      default: () => {},
      type: Object,
    },
    usersGuarantorIncome: {
      default: "",
      type: String,
    },
    usersGuarantorIncomeInput: {
      default: "",
      type: String,
    },
    usersStudy: {
      default: "",
      type: String,
    },
    usersStudyInput: {
      default: "",
      type: String,
    },
    usersExtraInformationIncome: {
      default: "",
      type: String,
    },
    usersExtraInformationIncomeInput: {
      default: "",
      type: String,
    },
    usersIncomeNote: {
      default: "",
      type: String,
    },
    usersLandlordDetails: {
      default: "",
      type: String,
    },
    usersLandlordLabel: {
      default: "",
      type: String,
    },
    usersLandlordRadio: {
      default: "",
      type: String,
    },
    usersLandlordOptions: {
      default: () => {},
      type: Object,
    },
    usersLandlordName: {
      default: "",
      type: String,
    },
    usersLandlordEmail: {
      default: "",
      type: String,
    },
    usersLandlordPhone: {
      default: "",
      type: String,
    },
    subscriptionsYourDetails: {
      default: "",
      type: String,
    },
    subscriptionsSexInput: {
      default: "",
      type: String,
    },
    subscriptionsSexOptions: {
      default: () => {},
      type: Object,
    },
    subscriptionsFirstName: {
      default: "",
      type: String,
    },
    subscriptionsFirstNameInput: {
      default: "",
      type: String,
    },
    subscriptionsMiddleName: {
      default: "",
      type: String,
    },
    subscriptionsMiddleNameInput: {
      default: "",
      type: String,
    },
    subscriptionsLastName: {
      default: "",
      type: String,
    },
    subscriptionsLastNameInput: {
      default: "",
      type: String,
    },
    subscriptionsPostCode: {
      default: "",
      type: String,
    },
    subscriptionsHouseNumber: {
      default: "",
      type: String,
    },
    subscriptionsStreet: {
      default: "",
      type: String,
    },
    subscriptionsCity: {
      default: "",
      type: String,
    },
    subscriptionsDateOfBirth: {
      default: "",
      type: String,
    },
    subscriptionsDateOfBirthInput: {
      default: "",
      type: String,
    },
    subscriptionsPhoneNumber: {
      default: "",
      type: String,
    },
    subscriptionsPhoneNumberInput: {
      default: "",
      type: String,
    },
    subscriptionsEmail: {
      default: "",
      type: String,
    },
    subscriptionsEmailInput: {
      default: "",
      type: String,
    },
    subscriptionsPassword: {
      default: "",
      type: String,
    },
    subscriptionsPasswordInput: {
      default: "",
      type: String,
    },
    subscriptionsPasswordRepeat: {
      default: "",
      type: String,
    },
    subscriptionsPasswordRepeatInput: {
      default: "",
      type: String,
    },
    subscriptionNumberOfAdults: {
      default: "",
      type: String,
    },
    subscriptionNumberOfAdultsValue: {
      default: "",
      type: String,
    },
    innerFormSubscriptions: {
      default: "",
      type: String,
    },
    innerFormUsersTitleOptions: {
      default: () => {},
      type: Object,
    },
    commonSend: {
      default: "",
      type: String,
    },
    subscribeToNewsletter: {
      default: "",
      type: String,
    },
    searchProfileTitle: {
      default: "",
      type: String,
    },
    spDistanceTitle: {
      default: "",
      type: String,
    },
    spDistanceOptions: {
      default: () => {},
      type: Object,
    },
    spDistanceValue: {
      default: "",
      type: String,
    },
    declineFormMessage: {
      default: "",
      type: String,
    },
    spCityTitle: {
      default: "",
      type: String,
    },
    spDistrictTitle: {
      default: "",
      type: String,
    },
    spRentalPriceFromTitle: {
      default: "",
      type: String,
    },
    spRentalPriceFromOptions: {
      default: () => {},
      type: Object,
    },
    spRentalPriceFromValue: {
      default: "",
      type: String,
    },
    spRentalPriceToTitle: {
      default: "",
      type: String,
    },
    spRentalPriceToOptions: {
      default: () => {},
      type: Object,
    },
    spRentalPriceToValue: {
      default: "",
      type: String,
    },
    spBedroomsTitle: {
      default: "",
      type: String,
    },
    spBedroomsOptions: {
      default: () => {},
      type: Object,
    },
    spBedroomsValue: {
      default: "",
      type: String,
    },
    spSurfaceTitle: {
      default: "",
      type: String,
    },
    spSurfaceOptions: {
      default: () => {},
      type: Object,
    },
    spSurfaceValue: {
      default: "",
      type: String,
    },
    spPropertyTypeTitle: {
      default: "",
      type: String,
    },
    spPropertyTypeOptions: {
      default: () => {},
      type: Object,
    },
    spPropertyTypeValue: {
      default: "",
      type: String,
    },
    spInteriorTitle: {
      default: "",
      type: String,
    },
    spInteriorOptions: {
      default: () => {},
      type: Object,
    },
    spInteriorValue: {
      default: "",
      type: String,
    },
    spSuitableForSharingTitle: {
      default: "",
      type: String,
    },
    spSuitableForSharingOptions: {
      default: () => {},
      type: Object,
    },
    spSuitableForSharingValue: {
      default: "",
      type: String,
    },
    spParkingSpaceTitle: {
      default: "",
      type: String,
    },
    spParkingSpaceOptions: {
      default: () => {},
      type: Object,
    },
    spParkingSpaceValue: {
      default: "",
      type: String,
    },
    spRentPeriodTitle: {
      default: "",
      type: String,
    },
    spRentPeriodOptions: {
      default: () => {},
      type: Object,
    },
    spRentPeriodValue: {
      default: "",
      type: String,
    },
    spStartDateRentTitle: {
      default: "",
      type: String,
    },
    spStartDateRentValue: {
      default: "",
      type: String,
    },
    spExtraInformationTitle: {
      default: "",
      type: String,
    },
    spNoPreference: {
      default: "",
      type: String,
    },
    spAdd: {
      default: "",
      type: String,
    },
    spReduce: {
      default: "",
      type: String,
    },
    spRentalTextTitle: {
      default: "",
      type: String,
    },
    spWeekPriceTitle: {
      default: "",
      type: String,
    },
    spNumberOfMenTitle: {
      default: "",
      type: String,
    },
    spNumberOfWomenTitle: {
      default: "",
      type: String,
    },
    spMinNumberOfBedroomsTitle: {
      default: "",
      type: String,
    },
    spParkingPlacesTitle: {
      default: "",
      type: String,
    },
    spParkingPlacesOptions: {
      default: () => {},
      type: Object,
    },
    isUserAlreadyExists: {
      default: "",
      type: String,
    },
    isUserBanned: {
      default: "",
      type: String,
    },
    phoneNumberAlreadyExists: {
      default: "",
      type: String,
    },
    websiteId: {
      default: "",
      type: String,
    },
    requestSrc: {
      default: "",
      type: String,
    },
    requestSrcInfo: {
      default: "",
      type: String,
    },
    checkBoxInfo: {
      default: "",
      type: String,
    },
    defaultLanguage: {
      default: "",
      type: String,
    },
    languages: {
      default: () => {},
      type: Object,
    },
  },
  methods: {
    triggerBusinessForm: function (value) {
      this.business_form_state = value;
      if (this.business_form_state === "1") this.number_of_adults_value = 1;
    },
    triggerFamilyType: function (value) {
      if (value)
        this.family_type_state = this.subscriptionsFamilyTypeSlugs[value];
      if (this.family_type_state == "living_together")
        this.number_of_adults_value = 2;
      if (this.family_type_state == "single") this.number_of_adults_value = 1;
      if (this.family_type_state == "several_friends")
        this.number_of_adults_value = this.subscriptionNumberOfAdultsValue;
    },
    triggerIncomeAdditionalForms: function (value) {
      if (value) this.income_form_state = value;

      this.income_form_any = false;
      this.income_form_studying = false;
      this.income_form_work_business = false;
      this.income_form_work = false;

      for (var i = 0; i < this.income_form_state.length; i++) {
        var state =
          this.subscriptionsTypeOfIncomeSlugs[this.income_form_state[i]];

        if (this.income_form_all_states.indexOf(state) > -1) {
          this.income_form_any = true;
          if (state == "own_business" || state == "working") {
            this.income_form_work_business = true;
          }
          if (state == "working") {
            this.income_form_work = true;
          }
          if (state == "studying") {
            this.income_form_studying = true;
          }
        }
      }
    },
    triggerContractDuration: function (value) {
      this.showDuration = false;
      var option = this.usersContractTypeAttributes[value];
      if (option == "1") {
        this.showDuration = true;
      }
    },
    triggerGuarantorForm: function (value) {
      if (value !== true) {
        this.guarantor_form_state = value;
      } else {
        this.guarantor_form_state = -1;
      }
    },
    triggerLandlordType: function (value) {
      this.landlord_type_state = value;
    },
    submitForm: function (e) {
      e.preventDefault();
      if (this.isSubmitInProgress) return;
      let that = this;
      this.isSubmitInProgress = true;
      this.$validator.validateAll().then((res) => {
        if (res) {
          let form = $("#form"),
            data = form.serialize(),
            element = document.getElementById("submitFormBtn");

          element.classList.add("disabled-state");

          setTimeout(function () {
            element.classList.remove("disabled-state");
          }, 2000);

          $.ajax({
            url: form.attr("action"),
            method: "post",
            data: data,
            success: function (result) {
              that.isSubmitInProgress = false;
              if (result && result.status && result.status == "error") {
                var message = result.message;
                sweetalert(window.app.locales.common.error, message, "error");
              } else {
                sweetalert(
                  window.app.locales.common.success,
                  window.app.locales.common.success_candidate_subscribe,
                  "success"
                ).then((res) => {
                  window.location.replace(result.url);
                });
              }
            },
            error: function (jqXHR, exception) {
              that.isSubmitInProgress = false;
              var message = jqXHR.responseJSON.message;
              sweetalert(window.app.locales.common.error, message, "error");
            },
          });
        } else {
          that.isSubmitInProgress = false;
          let i,
            errorsMsg = "",
            errorsList = document.createElement("ol"),
            errorsListBox = document.createElement("div");

          errorsList.classList.add("custom-errors-list");

          for (i = 0; i < this.$validator.errors.items.length; i++) {
            errorsMsg += "<li>" + this.$validator.errors.items[i].msg + "</li>";
          }

          errorsList.innerHTML = errorsMsg;
          errorsListBox.innerHTML =
            '<strong class="custom-errors-list__subtitle">The form contain some errors:</strong>';
          errorsListBox.appendChild(errorsList);

          sweetalert({
            title: "Opps!",
            content: errorsListBox,
            icon: "error",
          });
        }
      });
    },
    checkMail: function (event) {
      var email = event.target.value;
      if (email == "") return (this.is_user_already_exists = 0);
      var vm = this;
      $.ajax({
        url: `/api/users/check-mail`,
        method: "post",
        data: {
          email: email,
        },
        success: function (result) {
          var elements = document.getElementsByClassName("js-unique-mail"),
            mails = [];

          Array.prototype.forEach.call(elements, function (el) {
            let val = el.querySelector("input").value;
            if (el.querySelector("input") != event.target && val != "") {
              mails.push(val);
            }
          });

          if (parseInt(result) === 1) {
            vm.is_user_already_exists = 1;
          } else {
            if (mails.length && mails.indexOf(email) != -1) {
              vm.is_user_already_exists = 1;
            } else {
              vm.is_user_already_exists = 0;
            }
          }
        },
        error: function () {},
      });
    },
    checkPhone: function (event) {
      var phone = event.target.value;
      if (phone == "") return (this.is_phone_number_unique = 0);
      var vm = this;
      var elements = document.getElementsByClassName("js-unique-phone");
      var phones = [];
      Array.prototype.forEach.call(elements, function (el) {
        // Do stuff here
        let val = el.querySelector("input").value;
        if (el.querySelector("input") != event.target && val != "") {
          phones.push(val);
        }
      });
      if (phones.length && phones.indexOf(phone) != -1) {
        vm.is_phone_number_unique = 1;
      } else {
        vm.is_phone_number_unique = 0;
      }
    },
    checkPcHn(event) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        var postcode = $("[name='" + that.subscriptionsPostCode + "']")
          .first()
          .val();
        var house_number = $("[name='" + that.subscriptionsHouseNumber + "']")
          .first()
          .val();
        if (postcode && postcode != "") {
          $.post(
            "/get-street-location",
            {
              postcode: postcode,
              house_number: house_number,
            },
            function (data) {
              if (data.error == "false") {
                $("[name='" + that.subscriptionsCity + "']")
                  .first()
                  .val(data.location);
                $("[name='" + that.subscriptionsStreet + "']")
                  .first()
                  .val(data.street);

                var ref1 = "person_street_0";
                var ref2 = "person_city_0";
                that.$refs[ref1].model = data.street;
                that.$refs[ref2].model = data.location;
              }
            },
            "json"
          );
        }
      }, 100);
    },
    checkPostcodeAddress(event) {
      this.validated = false;
      this.changed = true;
      var that = this;
      setTimeout(function () {
        var street = $("[name='" + that.subscriptionsStreet + "']")
          .first()
          .val();
        var house_number = $("[name='" + that.subscriptionsHouseNumber + "']")
          .first()
          .val();
        var location = $("[name='" + that.subscriptionsCity + "']")
          .first()
          .val();
        if (street != "" && house_number != "") {
          $.post(
            `/get-postcode-by-address`,
            {
              street: street,
              house_number: house_number,
              location: location,
            },
            function (data) {
              if (data.error == "false") {
                $("[name='" + that.subscriptionsPostCode + "']")
                  .first()
                  .val(data.postcode);
                var ref = "person_postcode_0";
                that.$refs[ref].model = data.postcode;
              }
            },
            "json"
          );
        }
      }, 100);
    },
  },
  beforeMount() {
    this.triggerIncomeAdditionalForms();
    this.triggerFamilyType();
  },
};
</script>